import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimeDisplay from './DateTimeDisplay';

export default class CurriculumResourceCard extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    author: PropTypes.object.isRequired,
    posted_on: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    description: PropTypes.string,
    useTimezone: PropTypes.string,
  };

  static defaultProps = {
    description: '',
    useTimezone: moment.tz.guess(),
  };

  render() {
    return (
      <div className="Card-v2 Card-v2-padding">
        <div className="u-flex">
          <div className="u-inline-flex u-flex-col u-flex-shrink-0 u-w-10 u-mr-6 u-opacity-25">
            <img src={this.props.icon} alt="" />
          </div>
          <div className="u-flex u-flex-grow u-flex-col">
            <h3 className="u-my-0 u-text-sm">
              <a href={this.props.url}>{this.props.title}</a>
            </h3>
            <p className="u-text-grey u-text-xs">
              Resource added{' '}
              <DateTimeDisplay
                timestamp={this.props.posted_on}
                userTimezone={this.props.useTimezone}
                format="MMM D YYYY, h:mm A z"
                show_timezone
              />
            </p>
            <div dangerouslySetInnerHTML={{ __html: this.props.description }} />
          </div>
          <span className="label radius secondary u-ml-4">Learning resource</span>
        </div>
      </div>
    );
  }
}
